import type { HttpClient } from 'services/api-client/client';
import { returnData } from 'services/api-client/client';
import type { CodeOptimizerAPI } from '@env0/code-optimizer-service/api';

export default (client: HttpClient) => ({
  getIssues: (params: CodeOptimizerAPI.GetIssues.Request.QueryParams) =>
    client
      .get<CodeOptimizerAPI.GetIssues.Response>(`code-optimizer/issues`, {
        params
      })
      .then(returnData),
  getLatestScanStatus: (params: CodeOptimizerAPI.GetLatestScanStatus.Request.QueryParams) =>
    client
      .get<CodeOptimizerAPI.GetLatestScanStatus.Response>(`code-optimizer/scans/latest`, {
        params
      })
      .then(returnData),
  getIssue: (id: string) =>
    client.get<CodeOptimizerAPI.GetIssue.Response>(`code-optimizer/issues/${id}`).then(returnData),
  triggerCodeScan: (body: CodeOptimizerAPI.TriggerCodeScan.Request.Body) =>
    client.post<CodeOptimizerAPI.TriggerCodeScan.Response>(`code-optimizer/scans`, body).then(returnData),
  ignoreIssue: (id: string) =>
    client.post<CodeOptimizerAPI.IgnoreIssue.Response>(`code-optimizer/issues/${id}/ignore`).then(returnData),
  unignoreIssue: (id: string) =>
    client.post<CodeOptimizerAPI.UnignoreIssue.Response>(`code-optimizer/issues/${id}/unignore`).then(returnData),
  generateCodeForIssue: (id: string) =>
    client
      .post<CodeOptimizerAPI.GenerateCodeForIssue.Response>(`code-optimizer/issues/${id}/generate-code`)
      .then(returnData)
});
